module.exports = __webpack_public_path__ + "static/img/xishan-bg2.0ce13e06.png";